import { render } from "./InterfaceMainMenu.vue?vue&type=template&id=d2c98594&scoped=true"
import script from "./InterfaceMainMenu.vue?vue&type=script&lang=js"
export * from "./InterfaceMainMenu.vue?vue&type=script&lang=js"

import "./InterfaceMainMenu.vue?vue&type=style&index=0&id=d2c98594&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c98594"]])

export default __exports__